module.exports = __webpack_public_path__ + "img/icon_speaker_color.0b2e4763.svg";